import React from 'react'
import {useAuth} from './context/auth-context'
import useCallbackStatus from './utils/use-callback-status'
import {Form, Input, Button, Row, Col, Card} from 'antd';
import {UserOutlined, LockOutlined} from '@ant-design/icons';
import {useTranslation} from "./context/translation-context";

function LoginForm(props) {
    const {isPending, isRejected, error, run} = useCallbackStatus()
    const translation = useTranslation()
    const {login} = useAuth()

    function handleSubmit(values) {
        const {username, password} = values
        run(
            login({
                username: username,
                password: password,
            }),
        )
    }

    return (
        <Row style={{display: 'flex', justifyContent: 'center', padding: 12}}>
            <Col>
                <Card>
                    <Form
                        initialValues={{"username": props.customerName}}
                        style={{width: 300}}
                        name="normal_login"
                        onFinish={handleSubmit}
                    >
                        <Form.Item
                            name="username"
                            rules={[{
                                required: true,
                                message: translation.loginForm.messageUsername
                            }]}
                        >
                            <Input prefix={<UserOutlined className="site-form-item-icon"/>} placeholder={translation.loginForm.platzhalterUsername} />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[{required: true, message: translation.loginForm.messagePassword}]}
                        >
                            <Input
                                prefix={<LockOutlined className="site-form-item-icon"/>}
                                type="password"
                                placeholder={translation.loginForm.platzhalterPassword}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={isPending}>
                                {translation.loginForm.buttonLogin}
                            </Button>
                        </Form.Item>
                        {isRejected ? (
                            <div>{error ? error.response?.data?.fehlermeldung : null}</div>
                        ) : null}
                    </Form>
                </Card>
            </Col>
        </Row>
    )
}

export default LoginForm